var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-accordion',{attrs:{"name":"tenant-roster","section":"Tenant Roster","url":_vm.url,"method":"PATCH","closed":_vm.closed,"read_only":_vm.read_only}},[_c('square-feet',{attrs:{"read_only":_vm.read_only}}),_vm._v(" "),_c('tenant-roster',{attrs:{"property":_vm.property,"read_only":_vm.read_only}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }